export default __webpack_public_path__ + "static/media/discounts.739ba3b4.svg";